import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { theme, switchProp } from 'styled-tools'

const Pane = styled.div`
  background-color: ${theme('colors.white', '#fff')};
  padding: ${theme('pane.paddings.top')} ${theme('pane.paddings.horizontal')} ${theme('pane.paddings.bottom')};
  border-radius: ${theme('pane.radius')};
  box-shadow: ${switchProp('shadow', {
    default: theme('shadows.default'),
    high: theme('shadows.high')
  })};


  * + & {
    margin-top: ${theme('pane.paddings.top')};
  }
`

Pane.propTypes = {
  /** shadow of the pane */
  shadow: PropTypes.oneOf([
    'default',
    'high'
  ])
}

Pane.defaultProps = {
  shadow: 'default'
}

export default Pane
